import { DemoLight } from "../buttons";
import hero from "../images/home-hero.jpg";
import SocialsLinks from "../components/SocialsLinks";

export default function HomeHero() {
  return (
    <>
      <section className="bg-blue-100">
        <div className="px-5 2xl:px-0 md:grid grid-cols-2 gap-10 items-center xl:max-w-6xl xl:mx-auto py-10 lg:pt-48 lg:pb-20">
          <article className="mb-10 md:mb-0">
            <div className="visible md:invisible mb-5">
              <SocialsLinks />
            </div>
            <h1 className="mb-1 leading-tight">
              The Most Productive and Profitable Trading Platforms in One Place
            </h1>
            <p className="mb-5 lg:text-2xl">
              All your brokerage needs, in one place. We bring together the
              leading brokerage, advisory, and research solutions in one place.
              Get started today!
            </p>
            <div className="mt-8">
              <DemoLight />
            </div>
          </article>

          <article>
            <img
              src={hero}
              alt="The Most Productive and Profitable Trading Platforms in One Place"
              title="The Most Productive and Profitable Trading Platforms in One Place"
              className="block mx-auto homepage__image"
            />
          </article>
        </div>
      </section>
    </>
  );
}
